<template>
  <div class="progress__line">
    <div :style="'width:' + current + '%'"></div>
  </div>
</template>
<script>
export default {
  name: "ProgressLine",
  props: {
    current: Number,
  },
};
</script>
